import React from 'react';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import { PageLoading } from '../components/ui/Loading';
import { AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';

const AuthCallback: React.FC = () => {
  const { isLoading, error } = useAdminAuth();

  if (isLoading) {
    return <PageLoading message="Authenticating with Google..." />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
        <div className="max-w-md w-full bg-gray-800 rounded-lg border border-gray-700 p-8">
          <div className="flex items-center justify-center mb-6">
            <div className="p-3 bg-red-900/50 rounded-full">
              <AlertCircle className="h-8 w-8 text-red-400" />
            </div>
          </div>
          <h2 className="text-xl font-semibold text-white text-center mb-2">
            Authentication Failed
          </h2>
          <p className="text-gray-400 text-center mb-6">{error}</p>
          <Link to="/admin/login">
            <Button className="w-full">Back to Login</Button>
          </Link>
        </div>
      </div>
    );
  }

  return <PageLoading message="Redirecting..." />;
};

export default AuthCallback;
